import { nameof } from 'ts-simple-nameof';
import * as yup from 'yup';
import { customNullable } from '..';
import type { TravelDto, TravelInsuredDto } from '../../dtos';
import { Selection } from '../../enums';
import { isIn } from '../../Utils/comparisonUtils';


export const TravelValidationBaseObject = {
    // INSURERS
    [nameof<TravelDto>(x => x.insurers)]: yup
        .array()
        .nullable()
        .min(1, "Vyberte pojišťovnu"),

    [nameof<TravelDto>(x => x.range)]: yup.number().required('Vyberte rozsah pojištění'),
}

const insureeSchema = yup.object().shape({
    [nameof<TravelInsuredDto>(x => x.firstName)]: yup.string().required('Jméno je povinné'),
    [nameof<TravelInsuredDto>(x => x.lastName)]: yup.string().required('Příjmení je povinné'),
    [nameof<TravelInsuredDto>(x => x.birthdate)]: yup.date()
        .transform((value, originalValue) => originalValue === "" ? undefined : value)
        .required('Datum narození je povinné')
        .nullable(),
})

export const TravelValidationObject = {
    // INSURERS
    [nameof<TravelDto>(x => x.insurers)]: yup
        .array()
        .nullable()
        .min(1, "Vyberte pojišťovnu"),

    // v pripade ze je pojistena osoba pojistnikem, tak ji zbytecne duplicitne navalidujeme. Validace uz je na pojistnikovi
    [nameof<TravelDto>(x => x.insurees)]: yup.array().of(
        yup.lazy(insuree => {
            return !insuree[nameof<TravelInsuredDto>(x => x.isPolicyHolder)]
                ? insureeSchema
                : yup.object().shape({})
        })
    ),

    [nameof<TravelDto>(x => x.destination)]: customNullable(yup.number()).required('Vyberte destinaci'),

    [nameof<TravelDto>(x => x.reason)]: yup.number().when([nameof<TravelDto>(x => x.destination)], {
        is: (dest: number) => dest &&
            isIn(dest, Selection.TravelDestinationEurope, Selection.TravelDestinationWorld, Selection.TravelDestinationWorldWithoutNorthAmerica),
        then: () => customNullable(yup.number().required('Vyberte důvod cesty')),
        otherwise: () => customNullable(yup.number())
    }),

    [nameof<TravelDto>(x => x.destinationEuropeCountry)]: yup.number().when([nameof<TravelDto>(x => x.destination)], {
        is: (dest: number) => dest && Selection.TravelDestinationEurope == dest,
        then: () => customNullable(yup.number().required('Vyberte cílovou destinaci')),
        otherwise: () => customNullable(yup.number())
    }),

    [nameof<TravelDto>(x => x.travelType)]: customNullable(yup.number()).required('Vyberte druh cesty'),

    [nameof<TravelDto>(x => x.sportType)]: customNullable(yup.number()).required('Vyberte provozované sporty'),

    [nameof<TravelDto>(x => x.range)]: customNullable(yup.number()).required('Vyberte rozsah pojištění'),

    [nameof<TravelDto>(x => x.insuranceEndDate)]: yup.date().when([nameof<TravelDto>(x => x.travelType)], {
        is: (travType: number) => travType && Selection.TravelTypeShort == travType,
        then: () => customNullable(yup.mixed().required('Zadejte datum konce pojištění')),
        otherwise: () => customNullable(yup.mixed())
    }),
}

export const TravelValidationSchema = yup.object().shape(TravelValidationObject) as any
